import axios from 'axios';
import Cookies from "js-cookie";
// import { ElMessage } from "element-plus";

// // 线上
const requestMethodsUrl = 'http://kb.qikan.cn/api/admin'

// 本地
// const requestMethodsUrl = 'http://192.168.140.211:15066/admin'

// 代理开启
// const requestMethodsUrl = `${ window.location.protocol }//${ window.location.host }/api`


const requestMethods = (method, url, params, dataToParams = false, slot = false) => {
    return axios({
        method,
        url: requestMethodsUrl + url,
        headers: {
            'Content-Type': dataToParams ? 'application/json' : 'application/x-www-form-urlencoded',
            SystemId: "8023528739527225344",
            UnifiedToken: Cookies.get("userToken") || ''
        },
        params: dataToParams ? null : params,
        data: dataToParams ? params : null,
        traditional: true,
        responseType: slot ? 'blob' : null
    }).then(res => {
        return slot ? res : res.data
    })
    .catch((err) => {
        return err
    })
};

const formDataMethods = (method, url, params) => {
    return axios({
        method,
        url: requestMethodsUrl + url,
        headers: { "Content-Type": "multipart/form-data" },
        data:params
    }).then(res => {
        return res.data
    })
    .catch((err) => {
        return err
    })
};

export {
    requestMethods,
    formDataMethods
}
